import React from 'react';
import classNames from 'classnames';
import { LoadableOptions } from 'next/dynamic';
import Loading from '@/components/loading';
import styles from './style.module.scss';

export interface IEsConfig<T = any> extends LoadableOptions<T> {
  className?: string;
  autoFit?: boolean;
  style?: React.CSSProperties;
}

export function genEsConfig(props: IEsConfig = {}) {
  const { className = '', autoFit = false, style, ...rest } = props;
  return {
    ssr: false,
    loading: () => (
      <Loading style={style} className={classNames(className, styles.card, { [styles.autoFit]: !autoFit })} />
    ),
    ...rest,
  };
}

const esConfig = genEsConfig();

export default esConfig;
